export default __webpack_public_path__ + "static/media/Mercenary's Belt of Stalking Fury.7fc445ed.jpg";